module.exports = __webpack_public_path__ + "img/image-devices.6208ead7.png";